import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'custom-fields-description',
  templateUrl: './custom-fields-description.component.html',
  styleUrls: ['./custom-fields-description.component.scss'],
  standalone: false
})
export class CustomFieldsDescription {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
